import type { UserResponseDto } from '@/api';
import { environment } from '@/environments/environment';

const AVATAR_COLORS = [
  'bg-primary text-primary-content',
  'bg-secondary text-secondary-content',
  'bg-accent text-accent-content',
  'bg-info text-info-content',
  'bg-success text-success-content',
] as const;

export type AvatarColorClass = (typeof AVATAR_COLORS)[number];

export function getAvatarUrl(avatar: string | undefined): string | null {
  if (!avatar) return null;
  if (avatar.startsWith('http')) return avatar;
  return `${environment.apiUrl}${avatar.startsWith('/') ? '' : '/'}${avatar}`;
}

export function getUserInitials(user: UserResponseDto): string {
  const firstName = user.firstName?.trim();
  const lastName = user.lastName?.trim();
  if (firstName && lastName) {
    return (firstName[0] + lastName[0]).toUpperCase().slice(0, 2);
  }
  if (firstName) return firstName.slice(0, 2).toUpperCase();
  if (lastName) return lastName.slice(0, 2).toUpperCase();
  const nickname = user.nickname?.trim();
  if (nickname) return nickname.slice(0, 2).toUpperCase();
  const email = user.email?.trim() ?? '';
  return email[0]?.toUpperCase() ?? '?';
}

export function getAvatarColor(user: UserResponseDto): AvatarColorClass {
  const str = `${user.id}-${user.nickname ?? ''}-${user.email}`;
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  const index = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[index];
}
